import {
  ON_CLIENT_READ,
  ON_CLIENT_READING,
  ON_CLIENT_VALUE_CHANGE,
} from '../actions/types';

const INITIAL_STATE = {
  clients: [],
  loading: false,
  setReload: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ON_CLIENT_VALUE_CHANGE:
      return { ...state, ...action.payload };
    case ON_CLIENT_READING:
      return { ...state, loading: true };
    case ON_CLIENT_READ:
      return {
        ...state,
        clients: action.payload,
        loading: false,
      };
    default:
      return state;
  }
};
